export default "__VITE_ASSET__CivWxvf7__"